import jsonExport from 'jsonexport/dist';
import type { Exporter } from 'react-admin';
import { downloadCSV } from 'react-admin';
import { MemberSummary, Tag } from '@wwf/sdk';

export const memberExporter: Exporter<MemberSummary> = async (
    records,
    fetchRelatedRecords
) => {
    const tags = await fetchRelatedRecords<Tag>(records, 'tags', 'tags');

    const member = records.map(member => {
        const exportedMember = {
            ...member,
            antennas: member.antennas?.map(antenna => antenna.name).join(', '),
            tags: member.tags?.map(tagId => tags[tagId]?.name).join(', '),
        };
        delete (exportedMember as any).avatarInput;
        return exportedMember;
    });
    return jsonExport(member, {}, (_err: any, csv: string) => {
        downloadCSV(csv, 'member');
    });
};
